"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaLibraryBaseProvider = void 0;
const provider_base_1 = require("../provider-base");
const fragments_1 = require("../../fragments");
class MediaLibraryBaseProvider extends provider_base_1.BaseProvider {
    static async getMediaLibraryFragment() {
        const fragment = await fragments_1.FragmentsLoaderProvider.fragmentsLoader.loadFragment(fragments_1.FragmentName.mediaLibrary);
        return fragment;
    }
}
exports.MediaLibraryBaseProvider = MediaLibraryBaseProvider;
